import { CLAUSE_KEYWORD_BOUNDARY } from '../configs';
import { EGroupWithClause } from '../../types';

export interface IBuildGroupQueryParams {
  dimensions: string[];
  groupWithClause?: EGroupWithClause;
}

const build = (dimensions: string[], withClause = EGroupWithClause.ALL) =>
  dimensions.length === 0 ? '' : `GROUP BY ${dimensions.join(', ')} ${withClause}`;

const parse = (query: string): { dimensions: string[]; groupWithClause?: EGroupWithClause } => {
  const match = query.match(
    new RegExp(`\\bGROUP BY\\s+([\\s\\S]+?)(?=\\s+(?:${CLAUSE_KEYWORD_BOUNDARY})\\b)`, 'i'),
  );
  if (!match) return { dimensions: [] };

  const content = match[1].trim();
  const withIdx = content.toUpperCase().indexOf(' WITH ');

  if (withIdx === -1) {
    return {
      dimensions: content
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean),
      groupWithClause: EGroupWithClause.NONE,
    };
  }

  return {
    dimensions: content
      .slice(0, withIdx)
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean),
    groupWithClause: content.slice(withIdx + 1).trim() as EGroupWithClause,
  };
};

export { build as buildGroupQuery, parse as parseGroupQuery };
